import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Payment.css";
import backspaceImage from "../assets/images/backspace.png";
import { setPaymentData } from "../utils/paymentData";
import { useValidation } from "../contexts/ValidationContext";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { message, Modal, Spin, Form, Select } from "antd";
import PreviewReceipt from "../components/PreviewReceipt";
import AccessKeyModal from "../components/checkAccessKey";
import CloseButton from "../components/CloseButton";
import "../components/BillList.css";
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import config from "../config";
import { set, take } from "lodash";
import Swal from "sweetalert2";
import { io } from "socket.io-client";

const PaymentPage = ({
  settings,
  tableNumber,
  takeAwayTable,
  totalWithoutTaxes,
  totalCanDiscount,
  tableId,
  deposit,
  depositMethod,
  hasDeposit,
  orders,
  deliverDisableToggle,
  onPaymentValidation,
  showPaymentModal,
  orderID,
  selectedOrders,
  pax,
  services,
  taxesData,
}) => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("Cash"); // null = no method selected
  const [cashAmount, setCashAmount] = useState("0.00"); // Store cash input as string for easier appending
  const [transactionId, setTransactionId] = useState(""); // Transaction ID for transfer methods
  const [remarks, setRemarks] = useState(""); // Remarks for 'other' transfer methods
  const [discountAmount, setDiscountAmount] = useState("");
  const [isDiscountMode, setIsDiscountMode] = useState(false);
  const [discountType, setDiscountType] = useState(currency);
  const { updateValidation } = useValidation();
  const [isValidateDisabled, setIsValidateDisabled] = useState(true);
  //access key
  const accessKeyModalRef = useRef();
  const [showPreviewReceiptModal, setShowPreviewReceiptModal] = useState(false);
  const [allPayments, setAllPayments] = useState([]);
  const [newestInvoiceId, setNewestInvoiceId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  // const [taxesData, setTaxesData] = useState([
  //   {
  //     for_take_away: false,
  //     name: "Service Charge",
  //     rate: "10",
  //     __v: 0,
  //     _id: "68230d7ba366637ab8624cd9",
  //   },
  // ]);
  const [showTaxModal, setShowTaxModal] = useState(false);
  const [receiptData, setReceiptData] = useState([]);
  const [selectedTaxToRemove, setSelectedTaxToRemove] = useState(null);
  const paymentRef = useRef();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [printFirstPreview, setPrintFirstPreview] = useState(true);

  // Fetch payment methods from backend settings
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
        if (Array.isArray(data.paymentMethods)) {
          setPaymentMethods(data.paymentMethods.filter(m => m.enabled));
        } else {
          setPaymentMethods([]);
        }
      } catch (error) {
        setPaymentMethods([]);
      }
    };
    fetchPaymentMethods();
  }, [apiBaseUrl]);

  // const getAllTaxes = async () => {
  //   try {
  //     const { data } = await axios.get(`${apiBaseUrl}/api/taxes/get-taxes`);
  //     setTaxesData(data);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //   }
  // };

  // useEffect(() => {
  //   getAllTaxes();
  // }, []);

  const getAllPayments = async () => {
    console.log("Starting fetching....");
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/payments/today`);
      setAllPayments(data);

      let incrementedInvoiceId;

      // if (settings?.invoicePrefixToggle) {
      //   const prefix = settings.invoicePrefix || "";
      //   const startingNumber = settings.invoicePrefixNumber || 1;
      //   const suffix = settings.invoiceSuffix || "";

      //   if (data.length > 0) {
      //     const prefixPayments = data.filter(payment =>
      //       payment.invoiceId?.startsWith(prefix)
      //     );

      //     if (prefixPayments.length > 0) {
      //       const maxPayment = prefixPayments.reduce((max, payment) => {
      //         const currentNum = parseInt(payment.invoiceId?.replace(prefix, "") || "0");
      //         const maxNum = parseInt(max.invoiceId?.replace(prefix, "") || "0");
      //         return currentNum > maxNum ? payment : max;
      //       });

      //       const currentNum = parseInt(maxPayment.invoiceId.replace(prefix, ""));
      //       incrementedInvoiceId = `${prefix}${currentNum + 1}${suffix}`;
      //     } else {
      //       incrementedInvoiceId = `${prefix}${startingNumber}${suffix}`;
      //     }
      //   } else {
      //     incrementedInvoiceId = `${prefix}${startingNumber}${suffix}`;
      //   }
      // } else {
      // date
      if (data.length > 0) {
        const todayDate = getFormattedDate(new Date());
        const todayPrefix = `IV${todayDate}`;

        const todayPayments = data.filter(
          (payment) =>
            payment.invoiceId && payment.invoiceId.startsWith(todayPrefix)
        );

        if (todayPayments.length > 0) {
          const maxInvoicePayment = todayPayments.reduce((max, payment) => {
            const currentNumber = parseInt(payment.invoiceId.slice(10), 10);
            const maxNumber = parseInt(max.invoiceId.slice(10), 10);

            return currentNumber > maxNumber ? payment : max;
          });

          const currentMaxInvoiceId = maxInvoicePayment.invoiceId;
          const currentMaxNumber = parseInt(currentMaxInvoiceId.slice(10), 10);

          incrementedInvoiceId = `IV${todayDate}${currentMaxNumber + 1}`;
          console.log("is:", incrementedInvoiceId);
        } else {
          incrementedInvoiceId = `IV${todayDate}1`;
        }
      } else {
        const todayDate = getFormattedDate(new Date());
        incrementedInvoiceId = `IV${todayDate}1`;
      }
      // }

      console.log("Incremented Invoice ID:", incrementedInvoiceId);
      setNewestInvoiceId(incrementedInvoiceId);
    } catch (error) {
      console.error("Error fetching payments:", error);
    }
  };

  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  };

  const waitForNewestInvoiceId = async () => {
    console.log("Waiting for newest invoiceID....");
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (newestInvoiceId) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
      console.log("Finish getting invoiceID....");
    });
  };

  useEffect(() => {
    if (newestInvoiceId) {
      submitPayment();
    }
  }, [newestInvoiceId]);

  // Check for current logged-in user
  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      const { token } = auth;
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded.userId); // Set the current user

        // Navigate only if the user is on an invalid page
        if (window.location.pathname === "/login") {
          navigate("/"); // Redirect to the default page only if on login
        }
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("auth");
        navigate("/login"); // Redirect to login if token is invalid
      }
    } else {
      navigate("/login"); // Redirect to login if no auth is found
    }
  }, [navigate]);

  // Button Layouts for the payment page
  const buttonLayouts = {
    discount: [
      1,
      2,
      3,
      "%",
      4,
      5,
      6,
      currency,
      7,
      8,
      9,
      "",
      "Clear",
      0,
      "Backspace",
      "Pay",
    ],
    cash: [
      1,
      2,
      3,
      "",
      4,
      5,
      6,
      "",
      7,
      8,
      9,
      "",
      "Clear",
      0,
      "Backspace",
      "- Tax",
      "Discount",
      "Preview",
      "Confirm",
    ],
    cashless: ["Discount", "Preview", "- Tax", "Confirm"],
  };

  let layoutKey = "cash";
  if (isDiscountMode) layoutKey = "discount";
  else if (paymentMethod !== "Cash") layoutKey = "cashless";

  const buttonLayout = buttonLayouts[layoutKey];

  const toggleDiscountMode = (value) => {
    if (value === "Discount") {
      setIsDiscountMode(true);
    } else if (value === "Pay") {
      setIsDiscountMode(false);

      if (paymentMethod !== "Cash") {
        setTimeout(() => {
          inputRef.current.focus();
        }, 0);
      }
    }
  };

  // const handleQuickAdd = (value) => {
  //   if (isDiscountMode) {
  //     setDiscountAmount((prevAmount) => {
  //       const currentAmount = parseFloat(prevAmount || "0");
  //       return (currentAmount + value).toFixed(2);
  //     });
  //   } else {
  //     setCashAmount((prevAmount) => {
  //       const currentAmount = parseFloat(prevAmount || "0");
  //       return (currentAmount + value).toFixed(2);
  //     });
  //   }
  // };
  // Handle transaction ID input
  const handleTransactionIdChange = (e) => {
    setTransactionId(e.target.value);
  };

  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
  };

  const inputRef = useRef(null);

  // Handle payment method selection
  const selectPaymentMethod = (method) => {
    setPaymentMethod(method);
    setCashAmount("0.00"); // Reset cash amount when switching methods
    setTransactionId(""); // Reset transaction ID
    setDiscountAmount("");

    if (method !== "Cash") {
      setTimeout(() => {
        inputRef.current.focus();
      }, 0);
    }
  };

  // Handle number input
  const formatCurrencyInput = (prevAmount, value) => {
    const rawInput = (prevAmount.replace(/\D/g, "") || "") + value;
    const cleaned = rawInput.replace(/^0+/, "") || "0";
    const padded = cleaned.padStart(3, "0");
    const intPart = padded.slice(0, -2);
    const decPart = padded.slice(-2);
    return `${parseInt(intPart, 10)}.${decPart}`;
  };

  const formatPercentageInput = (prevAmount, value) => {
    const rawInput = (prevAmount.replace(/\D/g, "") || "") + value;
    const cleaned = rawInput.replace(/^0+/, "") || "0";
    return cleaned;
  };

  const handleNumberInput = (value) => {
    if (isDiscountMode) {
      if (discountType === currency) {
        setDiscountAmount((prevAmount) =>
          formatCurrencyInput(prevAmount, value)
        );
      } else if (discountType === "%") {
        setDiscountAmount((prevAmount) =>
          formatPercentageInput(prevAmount, value)
        );
      }
    } else {
      setCashAmount((prevAmount) => formatCurrencyInput(prevAmount, value));
    }
  };

  // Handle clearing the cash / discount input
  const clearInput = () => {
    if (isDiscountMode) {
      setDiscountType(null);
      setDiscountAmount("");
    } else {
      setCashAmount("0.00");
    }
  };

  // const addDecimal = () => {
  //   if (isDiscountMode) {
  //     setDiscountAmount((prev) => (!prev.includes(".") ? prev + "." : prev));
  //   } else {
  //     setCashAmount((prev) => (!prev.includes(".") ? prev + "." : prev));
  //   }
  // };

  // Function to handle backspace (removes last character)
  const handleBackspace = () => {
    const updater = (prevAmount) => {
      const rawInput = prevAmount.replace(/\D/g, ""); // remove non-digits

      const newRaw = rawInput.slice(0, -1); // remove last digit
      const cleaned = newRaw.replace(/^0+/, "") || "0";

      const padded = cleaned.padStart(3, "0");
      const intPart = padded.slice(0, -2);
      const decPart = padded.slice(-2);

      return `${parseInt(intPart, 10)}.${decPart}`;
    };

    if (isDiscountMode) {
      setDiscountAmount(updater);
    } else {
      setCashAmount(updater);
    }
  };

  const formatCashAmount = (amount) => {
    if (!amount) return "0.00";

    // Remove leading zeros unless it's a decimal like "0.50"
    if (/^0[0-9]+/.test(amount) && !amount.startsWith("0.")) {
      amount = String(parseFloat(amount));
    }

    // Ensure two decimal places
    if (amount.includes(".")) {
      const [int, dec = ""] = amount.split(".");
      if (dec.length === 0) return int + ".00";
      if (dec.length === 1) return int + "." + dec + "0";
      return int + "." + dec.slice(0, 2); // Optional: limit to 2 decimal places
    } else {
      return amount + ".00";
    }
  };
  const formatDiscount = (amount, type) => {
    if (!amount) return type === currency ? "0.00" : "0";

    // Remove leading zeros unless it's a decimal like 0.xx
    if (/^0[0-9]+/.test(amount) && !amount.startsWith("0.")) {
      amount = String(parseFloat(amount));
    }

    if (type === currency) {
      // 2 decimal places for RM
      if (amount.includes(".")) {
        const [int, dec = ""] = amount.split(".");
        if (dec.length === 0) return int + ".00";
        if (dec.length === 1) return int + "." + dec + "0";
        return int + "." + dec.slice(0, 2);
      } else {
        return amount + ".00";
      }
    } else {
      // 0 decimal places for percentage
      return String(Math.floor(parseFloat(amount)));
    }
  };

  //----------------------------------------------
  // Calculations for payment starts here
  //----------------------------------------------

  const calculateDiscount = () => {
    const discountValue = parseFloat(discountAmount || "0").toFixed(2);

    if (discountType === "%") {
      // Percentage discount calculation
      return (totalCanDiscount * parseFloat(discountValue)) / 100;
    }

    // Fixed $ discount calculation
    return parseFloat(discountValue).toFixed(2);
  };

  const calculateTotalAfterDiscount = () => {
    return (totalWithoutTaxes - calculateDiscount()).toFixed(2);
  };

  const calculateTaxes = (taxesData, totalAfterDiscount) => {
    if (taxesData.length === 0) {
      return [];
    }

    // tax rate need to save other part, don't change here. currently hardcode first
    return taxesData.map((tax) => {
      const shouldApplyTax = !takeAwayTable || tax.for_take_away;
      const removedTax = selectedTaxToRemove === tax._id;
      let taxRateCalculate = tax.rate;
      if (removedTax) {
        taxRateCalculate = 0;
      } else {
        tax.rate = taxRateCalculate;
      }
      const taxAmount =
        shouldApplyTax && !removedTax
          ? parseFloat(totalAfterDiscount * (taxRateCalculate / 100)).toFixed(2)
          : "0.00";

      return {
        taxName: tax.name,
        taxRateFixed: `${tax.rate}%`,
        taxRate: `${taxRateCalculate}%`,
        taxValidForTakeAway: tax.for_take_away,
        taxAmount,
      };
    });
  };

  const calculateTotalTaxes = () => {
    const totalTaxes = calculateTaxes(taxesData, totalAfterDiscount).reduce(
      (acc, tax) => acc + parseFloat(tax.taxAmount),
      0
    );

    return totalTaxes.toFixed(2);
  };

  const calculateTotalWithTaxes = () => {
    const taxes = calculateTaxes(taxesData, calculateTotalAfterDiscount());

    const totalTaxes = taxes.reduce(
      (acc, tax) => acc + parseFloat(tax.taxAmount),
      0
    );

    return (parseFloat(calculateTotalAfterDiscount()) + totalTaxes).toFixed(2);
  };

  const calculateTotalWithServices = () => {
    const totalServiceCharge = services.reduce(
      (total, s) => total + s.totalPrice,
      0
    );

    return (parseFloat(calculateTotalWithTaxes()) + totalServiceCharge).toFixed(
      2
    );
  };

  // Configuration for rounding behavior
  const ENABLE_ROUNDING_FOR_ALL_PAYMENTS = false; // Set to true to enable rounding for all payments

  const calculateRoundedTotalWithServices = () => {
    // Original behavior: only cash payments get rounded
    if (!ENABLE_ROUNDING_FOR_ALL_PAYMENTS) {
      if (paymentMethod === "Cash")
        return (Math.round(calculateTotalWithServices() * 20) / 20).toFixed(2);
      else return calculateTotalWithServices();
    }

    // New behavior: all payment methods get rounded
    return (Math.round(calculateTotalWithServices() * 20) / 20).toFixed(2);
  };

  const calculateRounding = () => {
    // Original behavior: only cash payments show rounding
    if (!ENABLE_ROUNDING_FOR_ALL_PAYMENTS) {
      if (paymentMethod === "Cash")
        return (
          parseFloat(calculateRoundedTotalWithServices()).toFixed(2) -
          parseFloat(calculateTotalWithServices()).toFixed(2)
        ).toFixed(2);
      else return "0.00";
    }

    // New behavior: all payment methods show rounding
    return (
      parseFloat(calculateRoundedTotalWithServices()).toFixed(2) -
      parseFloat(calculateTotalWithServices()).toFixed(2)
    ).toFixed(2);
  };

  // const calculateDeposit = () => {
  //   return parseFloat(depositAmount || "0").toFixed(2);
  // };

  const calculatePayableAmount = () => {
    const amount = calculateRoundedTotalWithServices() - deposit;
    return Math.max(amount, 0).toFixed(2);
  };

  const calculateBalance = () => {
    if (Math.round(discount) >= Math.round(totalWithoutTaxes)) {
      return (parseFloat(cashAmount || "0") - 0).toFixed(2);
    }
    return (parseFloat(cashAmount || "0") - calculatePayableAmount()).toFixed(
      2
    );
  };

  const discount = calculateDiscount(); // Step 2
  const totalAfterDiscount = calculateTotalAfterDiscount(); // Step 3
  const taxes = calculateTaxes(taxesData, totalAfterDiscount); // Step 4
  const totalTaxes = calculateTotalTaxes();
  const totalWithTaxes = calculateTotalWithTaxes(); // Step 5
  const totalWithServices = calculateTotalWithServices();
  const roundedTotalWithServices = calculateRoundedTotalWithServices(); // Step 7
  const rounding = calculateRounding(); // Step 8
  const balance = calculateBalance(); // Step 9

  // const deposit = calculateDeposit();
  const payableAmount = calculatePayableAmount();

  //----------------------------------------------
  // Calculations for payment ends here
  //----------------------------------------------

  // Place this useEffect AFTER all state and variable declarations (including discount, discountAmount, etc.)
  useEffect(() => {
    if (!showPaymentModal) return; // Only emit when modal is open

    // Emit previewReceipt event to customer display with latest info
    const userId = localStorage.getItem("userId");
    let socketUrl;
    try {
      socketUrl = new URL(apiBaseUrl).host;
    } catch {
      socketUrl = apiBaseUrl;
    }
    const socket = io(socketUrl, { query: { userId } });
    const formattedServices = services.map((s) => ({ ...s, totalPrice: s.totalPrice?.toFixed ? s.totalPrice.toFixed(2) : s.totalPrice }));
    const previewData = {
      totalWithoutTaxes,
      discount,
      discountAmount,
      discountType,
      totalAfterDiscount,
      taxes,
      totalTaxes,
      totalWithTaxes,
      totalWithServices,
      rounding,
      roundedTotalWithServices,
      deposit,
      payableAmount,
      depositMethod,
      cashAmount,
      balance,
      paymentMethod,
      transactionId,
      newestInvoiceId: null,
      remarks,
      currentCashierName: currentUser,
      isPreview: true,
      orderDetails: orders,
    };
    socket.emit("previewReceipt", {
      userId,
      paymentData: previewData,
      tableNumber,
      pax,
      services: formattedServices,
      takeAwayTable,
    });
  }, [
    discount,
    discountAmount,
    discountType,
    cashAmount,
    paymentMethod,
    transactionId,
    remarks,
    totalWithoutTaxes,
    totalAfterDiscount,
    taxes,
    totalTaxes,
    totalWithTaxes,
    totalWithServices,
    rounding,
    roundedTotalWithServices,
    deposit,
    payableAmount,
    depositMethod,
    cashAmount,
    balance,
    paymentMethod,
    transactionId,
    newestInvoiceId,
    remarks,
    orders,
    showPaymentModal,
    apiBaseUrl,
    services,
    tableNumber,
    pax,
    takeAwayTable,
  ]);

  useEffect(() => {
    if (
      parseFloat(cashAmount || "0") >= payableAmount ||
      transactionId.trim() !== ""
    ) {
      setIsValidateDisabled(false);
    } else {
      setIsValidateDisabled(true);
    }
  }, [payableAmount, cashAmount, transactionId]);

  const handleValidate = async () => {
    if (parseFloat(cashAmount) < payableAmount) {
      return;
    }

    // Emit previewReceipt event to customer display with latest info
    const userId = localStorage.getItem("userId");
    let socketUrl;
    try {
      socketUrl = apiBaseUrl;
    } catch {
      socketUrl = apiBaseUrl;
    }
    const socket = io(socketUrl, { query: { userId } });
    const formattedServices = services.map((s) => ({ ...s, totalPrice: s.totalPrice?.toFixed ? s.totalPrice.toFixed(2) : s.totalPrice }));
    const previewData = {
      totalWithoutTaxes,
      discount,
      totalAfterDiscount,
      taxes,
      totalTaxes,
      totalWithTaxes,
      totalWithServices,
      rounding,
      roundedTotalWithServices,
      deposit,
      payableAmount,
      depositMethod,
      cashAmount,
      balance,
      paymentMethod,
      transactionId,
      newestInvoiceId: null,
      remarks,
      currentCashierName: currentUser,
      isPreview: true,
      orderDetails: orders,
    };
    socket.emit("previewReceipt", {
      userId,
      paymentData: previewData,
      tableNumber,
      pax,
      services: formattedServices,
      takeAwayTable,
    });
    // Continue with validation
    try {
      validateInvoiceId();
    } catch (error) {
      // message.error('Something Went Wrong');
      Swal.fire({
        icon: "error",
        title: "Failed to delete order. Please try again.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const validateInvoiceId = async () => {
    console.log("Submit payment....");
    let userId;
    if (settings.isAccessKeyNeeded) {

      const operator = await accessKeyModalRef.current?.show();
      if (!operator) {
        setIsLoading(false);
        setIsProcessing(false);
        return;
      } else {
        userId = operator?.user?.userId;
      }
    } else {
      userId = localStorage.getItem("userId");
    }

    console.log('userId: ', userId);

    setIsLoading(true);
    setIsProcessing(true);

    setCurrentUser(userId);

    if (!newestInvoiceId) {
      await getAllPayments();
      await waitForNewestInvoiceId();
    } else {
      submitPayment();
    }
  };

  // const generateInvoiceId = (number) => {
  //   return `IV${String(number).padStart(6, "0")}`; // Format as IV000001, IV000002, etc.
  // };

  // Function to submit the payment
  const submitPayment = async () => {
    const userId = localStorage.getItem("userId");
    let socketUrl;
    try {
      socketUrl = apiBaseUrl;
    } catch {
      socketUrl = apiBaseUrl;
    }

    const socket = io(socketUrl, {
      query: { userId: userId },
    });

    setIsProcessing(false);
    setIsProcessing(true);
    setIsLoading(false);
    setIsLoading(true);
    handleDeposit();
    // Filter out orders that are marked as "Paid"
    const unpaidOrders = orders.filter((order) => order.status !== "Paid");

    const formattedServices = services.map((s) => {
      return {
        ...s,
        totalPrice: s.totalPrice.toFixed(2),
      };
    });

    var paymentData = {};

    // If there are no unpaid orders, return early
    if (unpaidOrders.length === 0) {
      message.warning("No orders need to be paid.");
      onPaymentValidation(paymentData);
    } else {
      paymentData = {
        invoiceId: newestInvoiceId,
        cashierName: currentUser,
        tableNo: tableNumber,
        method: paymentMethod,
        transactionId: paymentMethod === "Cash" ? null : transactionId,
        remarks: paymentMethod === "Other" ? remarks : null,
        billAmount: {
          total: totalWithoutTaxes,
          discount: discount,
          discountType: discountType,
          discountAmount: discountAmount,
          subTotal: totalAfterDiscount,
          taxes: taxes,
          services: formattedServices,
          grandTotalBeforeRounding: totalWithServices,
          rounding: rounding,
          grandTotal: roundedTotalWithServices,
          payableAmount: payableAmount,
          deposit: {
            haveDeposit: hasDeposit,
            amount: deposit,
            method: depositMethod,
          },
        },
        orderDetails: orders,
        pax: Number(pax),
        paid:
          paymentMethod === "Cash" ? parseFloat(cashAmount).toFixed(2) : "0.00",
        balance:
          paymentMethod === "Cash" ? Math.max(balance, 0.0).toFixed(2) : "0.00",
        takeAway: takeAwayTable,
      };
      const currentCashierName = currentUser;

      setPaymentData(
        totalWithoutTaxes,
        discount,
        discountAmount,
        discountType,
        totalAfterDiscount,
        taxes,
        totalTaxes,
        totalWithTaxes,
        totalWithServices,
        rounding,
        roundedTotalWithServices,
        deposit,
        payableAmount,
        depositMethod,
        cashAmount,
        balance,
        paymentMethod,
        transactionId,
        newestInvoiceId,
        remarks,
        currentCashierName
      );
      updateValidation(true, tableNumber);

      try {
        const response = await axios.post(
          `${apiBaseUrl}/api/payments`,
          paymentData
        );
        setReceiptData(response.data);
        socket.emit("newPayment", {
          userId,
          receipt: response.data,
          paymentData: {
            totalWithoutTaxes,
            discount,
            totalAfterDiscount,
            taxes,
            totalTaxes,
            totalWithTaxes,
            totalWithServices,
            rounding,
            roundedTotalWithServices,
            deposit,
            payableAmount,
            depositMethod,
            cashAmount,
            balance,
            paymentMethod,
            transactionId,
            newestInvoiceId,
            remarks,
            currentCashierName,
          },
        });

        if (paymentMethod === "Cash") {
          // Send the payload to the backend API
          try {
            await axios.post(
              `${apiBaseUrl}/api/opencashdrawer`, {
              selectedPrinterId: localStorage.getItem("selectedPrinterId"),
            }
            );
            console.log("Cash drawer opened successfully:");
          } catch (error) {
            console.error("Error opening cash drawer:", error);
          }

        }

        onPaymentValidation(paymentData);
      } catch (error) {
        console.error("Error storing payment:", error);
      }
    }
  };

  const handleShowPreviewReceipt = () => {
    setShowPreviewReceiptModal(true);
  };

  // const handleShowDepositMethod = (method) => {
  //   setShowDepositMethodModal(true);
  // };

  const handleDeposit = async () => {
    try {
      const payload = {
        tableId: tableId,
        hasDeposit: false,
        deposit: {
          depositAmount: "0.00",
          depositMethod: "Paynow",
          depositNote: "",
        },
      };

      const response = await axios.put(
        `${apiBaseUrl}/api/tables/edit-table`,
        payload
      );

      if (response.status === 200) {
        console.log("Deposit updated successfully:", response.data);
      } else {
        console.error("Failed to update deposit:", response.data);
      }
    } catch (error) {
      console.error("Error updating deposit:", error);
    }
  };

  return (
    <div className="payment-container">
      <>
        <style>
          {`
    /* Container Styling */
    // .payment-container {
    //   font-family: 'Poppins', sans-serif;
    //   max-width: 800px;
    //   margin: 50px auto;
    //   padding: 20px;
    //   background: linear-gradient(145deg, #ffffff, #f7f9fc);
    //   border-radius: 20px;
    //   box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    //   color: #2c3e50;
    // }


    .payment-header {
      text-align: center;
    }

    .table-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .table-info h2 {
      font-size: 2rem;
      color: #34495e;
      margin: 0;
    }

    /* Payment Method Buttons */

    .payment-body {
      display:flex;
      justify-content: space-around;
    }

    .payment-methods {
      display: flex;
      flex-direction: column;
      gap: 15px;
      justify-content: flex-start;
      align-items: flex-start; 
      margin-bottom: 30px;
      height: 100%;
    }

    .payment-button {
      display:flex;
      align-items: center;
      justify-items: center;
      justify-content: space-evenly;
      background: #ecf0f1;
      border: 2px solid transparent;
      padding: 10px;
      border-radius: 12px;
      text-align: center;
      transition: all 0.3s ease;
      cursor: pointer;
      width: 180px;
      gap: 15px;
    }

    .payment-button:hover {
      background: #dfe6e9;
      transform: translateY(-5px);
    }

    .payment-button.selected {
      background: #3498db;
      color: #fff;
      border-color: #2980b9;
    }

    .payment-icon {
      width: 45px;
    }

    .payment-button span {
      display: block;
      font-size: 1rem;
      font-weight: bold;
    }

    /* Payment Center */
    .payment-center {
      width: 75%;
      text-align: center;
      padding: 10px;
    }

    .payment-center .cash-payment {
      border-radius: 12px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }


    .cash-payment .total-display p {
      margin-bottom: 0px !important;
      justify-content: center;
    }
    
    .cash-payment .total-display p h4{
    }

    .cash-payment .total-display h3 {
      font-size: 1.5rem;
      color: #2c3e50;
      margin-bottom: 0px !important;
    }

    .cash-payment .total-display h4 {
      font-size: 1.2rem;
      margin-top: 0px;
      margin-bottom: 0px;
    }

    /* Numpad Styling */
    .numpad {
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* Maintain 4 columns for the numpad buttons */
      gap: 10px; /* Space between buttons */
      margin-top: 20px; /* Space above the numpad */
      justify-content: flex-end; /* Ensure numpad stays aligned to the right */
      margin-left: auto; /* Push the numpad to the right side of the container */
      width: auto; /* Let the numpad adjust dynamically or set a fixed width if needed */
    }


    .numpad-button {
      padding: 15px;
      font-size: 1.2rem;
      border-radius: 8px;
      border: 1px solid #bdc3c7;
      background: #ffffff;
      color: #000000;
      transition: background-color 0.3s ease, transform 0.2s ease;
      cursor: pointer;
    }

    .numpad-button:hover {
      background: #f1f1f1;
      transform: scale(1.05);
    }

    .numpad-button.focused {
      background-color: #3498db;
      color: #ffffff;
      border: 1px solid #2980b9;
    }

    .disabled-button {
      background-color: #d4d4d4 !important; 
      color: #a1a1a1 !important;        
      cursor: not-allowed;   
    }

    /* Transaction Section */
    .transaction-id-section {
      background: #f9f9f9;
      padding: 20px;
      border-radius: 12px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

    .transaction-id-section h3 {
      font-size: 1.5rem;
      color: #34495e;
    }

    .transaction-input {
      width: 100%;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #bdc3c7;
      margin-bottom: 15px;
    }

    // .submit-button {
    //   padding: 10px 20px;
    //   background: #3498db;
    //   color: white;
    //   font-size: 1rem;
    //   border-radius: 8px;
    //   border: none;
    //   cursor: pointer;
    //   transition: all 0.3s ease;
    // }

    // .submit-button:hover {
    //   background: #2980b9;
    // }

    /* Responsiveness */
    @media (max-width: 768px) {
      .payment-container {
        padding: 15px;
      }

      .payment-button {
        padding: 10px;
      }

      .numpad-button {
        padding: 10px;
      }
    }

    .backspace-icon {
      //display: flex;
      justify-content: center;  /* Aligns the image horizontally */
      align-items: center;      /* Aligns the image vertically */
      padding: 4px;
      width: 40px;
      height: 30px;
    }
      
      .cash-pay-button {
        background-color: #4CAF50 !important;
        color: white !important;
        border: 1px solid #4CAF50 !important;
        font-weight: bold;
        padding: 15px;
        font-size: 1.2rem;
        border-radius: 8px;
        transition: background-color 0.3s ease, transform 0.2s ease;
        cursor: pointer;
        grid-column: span 2;
      }

      .cash-pay-button:hover {
        background: #f1f1f1;
        transform: scale(1.05);
      }

      .cash-pay-button:disabled {
        background-color: #d4d4d4 !important; 
        color: #a1a1a1 !important;
        border: 1px solid #c6c6c6 !important;
        cursor: not-allowed !important;
        transform: none;
      }

      .cashless-pay-button {
        background-color: #4CAF50 !important;
        color: white !important;
        border: 1px solid #4CAF50 !important;
        font-weight: bold;
        padding: 15px;
        font-size: 1.2rem;
        border-radius: 8px;
        transition: background-color 0.3s ease, transform 0.2s ease;
        cursor: pointer;
        grid-column: span 1;
      }

      .cashless-pay-button:hover {
        background: #f1f1f1;
        transform: scale(1.05);
      }

      .cashless-pay-button:disabled {
        background-color: #d4d4d4 !important; 
        color: #a1a1a1 !important;
        border: 1px solid #c6c6c6 !important;
        cursor: not-allowed !important;
        transform: none;
      }
        
      .transaction-id-input {
        visibility: hidden;
        height:0;
      }

      .transaction-id-input.visible {
        visibility: visible;
        height:80px;
      }

      .remark-input {
        visibility: hidden;
        height:0;
      }

      .remark-input.visible {
        visibility: visible;
        height:80px;
      }

      .loading-overlay {
        position: fixed; /* Fixed position to cover the entire viewport */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.1); /* Semi-transparent background */
        display: flex; /* Use flexbox to center the spinner */
        justify-content: center; /* Center horizontally */
        align-items: center; /* Center vertically */
        z-index: 1000; /* High z-index to overlay on top of other content */
      }

      .payment-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin: 2px;
        page-break-inside: avoid;
      }

      .payment-label {
        text-align: left;
        margin-left: 30px;
        //margin-right: 5px;
      }

      .payment-value {
        //margin-left: 5px;
        text-align: left;
      }
    `}
        </style>
      </>
      {isLoading && (
        <div className="loading-overlay">
          <Spin size="large" />
        </div>
      )}
      <header className="payment-header"></header>

      <div className="payment-body">
        <div className="payment-methods">
          {paymentMethods.map(({ id, img, name }) => (
            <button
              key={id}
              onClick={() => selectPaymentMethod(id)}
              className={`payment-button ${paymentMethod === id ? "selected" : ""}`}
            >
              {img && (
                <img src={img} alt={`${name} Logo`} className="payment-icon" />
              )}
              <span>{name}</span>
            </button>
          ))}
        </div>

        <Modal
          title={
            <div>
              Preview Receipt
              <CloseButton
                className="close-button"
                onClick={() => {
                  setShowPreviewReceiptModal(false);
                  // Do NOT emit closePreviewReceipt here
                }}
              />
            </div>
          }
          open={showPreviewReceiptModal}
          onCancel={() => {
            setShowPreviewReceiptModal(false);
          }}
          onOk={() => {
            // window.print();
            paymentRef.current?.printPreviewReceipt();

            setTimeout(() => {
              setShowPreviewReceiptModal(false);
            }, 500);
          }}
          okText={printFirstPreview ? "Print" : "Print Copy"}
          className="print-modal"
        >
          <PreviewReceipt
            ref={paymentRef}
            totalWithoutTaxes={totalWithoutTaxes}
            totalCanDiscount={totalCanDiscount}
            totalAfterDiscount={totalAfterDiscount}
            roundingAmount={rounding}
            totalWithServices={totalWithServices}
            roundedTotalWithServices={roundedTotalWithServices}
            deposit={deposit}
            payableAmount={payableAmount}
            depositMethod={depositMethod}
            orders={orders.filter((order) => {
              if (deliverDisableToggle) {
                return (
                  order.order_progressstatus === "Receive" ||
                  order.order_progressstatus === "Kitchen"
                );
              } else {
                return order.order_progressstatus === "Receive";
              }
            })}
            taxes={calculateTaxes(taxesData, totalAfterDiscount) || []} // Provide a default empty array if `taxes` is undefined
            tableNumber={tableNumber}
            selectedOrders={selectedOrders}
            pax={pax}
            discount={discount}
            discountType={discountType}
            discountAmount={discountAmount}
            services={services}
            takeAwayTable={takeAwayTable}
            setPrintFirstPreview={setPrintFirstPreview}
          />
        </Modal>

        {showTaxModal && (
          <Modal
            title={
              <div>
                Remove Tax
                <CloseButton
                  className="close-button"
                  onClick={() => setShowTaxModal(false)}
                />
              </div>
            }
            open={showTaxModal}
            onCancel={() => {
              setSelectedTaxToRemove(null);
              setShowTaxModal(false);
            }}
            onOk={() => {
              setShowTaxModal(false);
            }}
          >
            <Form>
              <Form.Item>
                <p style={{ fontSize: "16px" }}>
                  Click "OK" to remove the selected tax from payment.
                </p>

                <Select
                  style={{ width: "100%" }}
                  placeholder="Select a tax to remove"
                  onChange={(value) => setSelectedTaxToRemove(value)}
                >
                  {taxesData
                    .filter(
                      (tax) => !takeAwayTable || tax.for_take_away === true
                    )
                    .map((tax) => (
                      <Select.Option key={tax._id} value={tax._id}>
                        {tax.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Form>
          </Modal>
        )}

        {/* Payment Center */}
        <div className="payment-center">
          {paymentMethod === "Cash" && (
            <div className="cash-payment">
              <div className="total-display">
                <p className="payment-row">
                  <span className="payment-label" style={{ fontSize: "16px" }}>
                    Total:
                  </span>
                  <strong
                    className="payment-value"
                    style={{ fontSize: "16px" }}
                  >
                    {symbol} {parseFloat(totalWithoutTaxes).toFixed(2)}
                  </strong>
                </p>
                <p
                  style={{
                    border: isDiscountMode ? "2px solid #e67e22" : "none",
                    padding: "5px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    borderRadius: "5px",
                  }}
                  className="payment-row"
                >
                  <span className="payment-label" style={{ fontSize: "16px" }}>
                    {" "}
                    Discount:
                  </span>
                  <strong
                    className="payment-value"
                    style={{ fontSize: "16px" }}
                  >
                    {discountType === currency
                      ? `${symbol} ${formatDiscount(
                        discountAmount,
                        discountType
                      )}`
                      : `${formatDiscount(discountAmount, discountType)} %`}
                  </strong>
                </p>
                <p className="payment-row">
                  <span className="payment-label" style={{ fontSize: "16px" }}>
                    Subtotal (Inclusive Taxes):
                  </span>
                  <strong
                    className="payment-value"
                    style={{ fontSize: "16px" }}
                  >
                    {symbol} {parseFloat(totalWithTaxes).toFixed(2)}
                  </strong>
                </p>
                <p className="payment-row">
                  <span className="payment-label" style={{ fontSize: "16px" }}>
                    Deposit:
                  </span>
                  <strong
                    className="payment-value"
                    style={{ fontSize: "16px" }}
                  >
                    {symbol} {deposit}
                  </strong>
                </p>
                <h3 className="payment-row">
                  <span className="payment-label">Grand Total:</span>
                  <strong className="payment-value">
                    {symbol} {payableAmount}
                  </strong>
                </h3>
                <p
                  style={{
                    border: isDiscountMode ? "none" : "2px solid #3498db",
                    padding: "5px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    borderRadius: "5px",
                    fontSize: "1.5em",
                  }}
                  className="payment-row"
                >
                  <span className="payment-label">Cash Entered:</span>
                  <h4 className="payment-value">
                    {symbol} {formatCashAmount(cashAmount) || "0.00"}
                  </h4>
                </p>
                {cashAmount !== "0.00" && (
                  <h4 className="payment-row">
                    <span className="payment-label">Balance:</span>
                    <span
                      style={{
                        color: parseFloat(balance) >= 0 ? "#27ae60" : "#e74c3c",
                      }}
                      className="payment-value"
                    >
                      {symbol}{" "}
                      {parseFloat(balance) >= 0
                        ? parseFloat(balance).toFixed(2)
                        : "0.00"}
                    </span>
                  </h4>
                )}
              </div>

              <div className="numpad">
                {buttonLayout.map((value, index) => {
                  // Calculate the `disabled` state for the current button
                  const disabled =
                    isProcessing ||
                    (value === "Confirm" ? isValidateDisabled : false) ||
                    ((value === "Pay" || value === "Preview") &&
                      isDiscountMode &&
                      (parseFloat(roundedTotalWithServices).toFixed(2) < 0 ||
                        isNaN(
                          parseFloat(roundedTotalWithServices).toFixed(2)
                        ))) ||
                    (value === "Confirm" && isLoading) ||
                    value === "";

                  return (
                    <button
                      key={index}
                      onClick={() => {
                        if (!isProcessing) {
                          if (typeof value === "number") {
                            handleNumberInput(value.toString()); // For normal numbers
                            updateValidation(false, tableNumber);
                          } else if (value === "%") {
                            setDiscountType("%");
                            updateValidation(false, tableNumber);
                          } else if (value === currency) {
                            setDiscountType(currency);
                            updateValidation(false, tableNumber);
                          } else if (value === "Clear") {
                            clearInput(); // Clear input
                            updateValidation(false, tableNumber);
                          } else if (value === "Backspace") {
                            handleBackspace(); // Backspace functionality
                            updateValidation(false, tableNumber);
                          } else if (value === "Confirm") {
                            setIsLoading(true);
                            setIsProcessing(true);
                            handleValidate();
                          } else if (value === "- Tax") {
                            setSelectedTaxToRemove(null);
                            setShowTaxModal(true);
                          } else if (value === "Discount" || value === "Pay") {
                            toggleDiscountMode(value);
                          } else if (value === "Preview") {
                            handleShowPreviewReceipt();
                          }
                        }
                      }}
                      disabled={isProcessing || disabled}
                      className={`numpad-button 
                          ${(value === "Pay" && isDiscountMode) ||
                          (value === "Discount" && !isDiscountMode)
                          ? "focused"
                          : ""
                        } 
                          ${value === "Confirm" ? "cash-pay-button" : ""} 
                          ${isProcessing || disabled ? "disabled-button" : ""}`}
                    >
                      {value === "Backspace" ? (
                        <img
                          src={backspaceImage}
                          alt="Backspace"
                          className="backspace-icon"
                        />
                      ) : (
                        value
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {paymentMethod !== "Cash" && (
            <div className="transaction-id-section">
              <h3 className="payment-row">
                <span className="payment-label">Grand Total:</span>
                <strong className="payment-value">
                  {symbol} {parseFloat(payableAmount).toFixed(2)}
                </strong>
              </h3>
              <p className="payment-row">
                <span className="payment-label" style={{ fontSize: "16px" }}>
                  {" "}
                  Deposit:
                </span>
                <strong className="payment-value" style={{ fontSize: "16px" }}>
                  {symbol} {deposit}
                </strong>
              </p>
              <p className="payment-row">
                <span className="payment-label">Total:</span>
                <strong className="payment-value">
                  {symbol} {parseFloat(totalWithoutTaxes).toFixed(2)}
                </strong>
              </p>
              <p
                style={{
                  border: isDiscountMode ? "2px solid #e67e22" : "none",
                  padding: "5px",
                  paddingLeft: "0px",
                  borderRadius: "5px",
                }}
                className="payment-row"
              >
                <span className="payment-label">Discount:</span>
                <strong className="payment-value">
                  {discountType === currency
                    ? `${symbol} ${formatDiscount(
                      discountAmount,
                      discountType
                    )}`
                    : `${formatDiscount(discountAmount, discountType)} %`}
                </strong>
              </p>
              <p className="payment-row">
                <span className="payment-label">
                  Subtotal (Inclusive Taxes):
                </span>
                <strong className="payment-value">
                  {symbol} {parseFloat(totalWithTaxes).toFixed(2)}
                </strong>
              </p>
              <div
                className={`transaction-id-input ${!isDiscountMode ? "visible" : ""
                  }`}
              >
                <p>Enter Transaction ID:</p>
                <input
                  type="text"
                  value={transactionId}
                  onChange={handleTransactionIdChange}
                  placeholder="Transaction ID"
                  className="transaction-input"
                  ref={inputRef}
                  maxLength={16}
                />
              </div>
              <div className="numpad">
                {buttonLayout.map((value, index) => {
                  // Calculate the `disabled` state for the current button
                  const disabledVTD =
                    isProcessing ||
                    (value === "Confirm" ? isValidateDisabled : false) ||
                    ((value === "Pay" || value === "Preview") &&
                      isDiscountMode &&
                      (parseFloat(roundedTotalWithServices).toFixed(2) < 0 ||
                        isNaN(
                          parseFloat(roundedTotalWithServices).toFixed(2)
                        ))) ||
                    (value === "Confirm" && isLoading) ||
                    value === "";
                  return (
                    <button
                      key={index}
                      onClick={() => {
                        if (!isProcessing) {
                          if (typeof value === "number") {
                            handleNumberInput(value.toString()); // For normal numbers
                            updateValidation(false, tableNumber);
                          } else if (value === "%") {
                            setDiscountType("%");
                            updateValidation(false, tableNumber);
                          } else if (value === currency) {
                            setDiscountType(currency);
                            updateValidation(false, tableNumber);
                          } else if (value === "Clear") {
                            clearInput(); // Clear input
                            updateValidation(false, tableNumber);
                          } else if (value === "Backspace") {
                            handleBackspace(); // Backspace functionality
                            updateValidation(false, tableNumber);
                          } else if (value === "Confirm") {
                            setIsLoading(true);
                            setIsProcessing(true);
                            validateInvoiceId();
                          } else if (value === "- Tax") {
                            setSelectedTaxToRemove(null);
                            setShowTaxModal(true);
                          } else if (value === "Discount" || value === "Pay") {
                            toggleDiscountMode(value);
                          } else if (value === "Preview") {
                            handleShowPreviewReceipt();
                          }
                        }
                      }}
                      disabled={isProcessing || disabledVTD}
                      className={`numpad-button 
                        ${(value === "Pay" && isDiscountMode) ||
                          (value === "Discount" && !isDiscountMode)
                          ? "focused"
                          : ""
                        } 
                        ${value === "Confirm" ? "cashless-pay-button" : ""} 
                        ${isProcessing || disabledVTD ? "disabled-button" : ""
                        }`}
                    >
                      {value === "Backspace" ? (
                        <img
                          src={backspaceImage}
                          alt="Backspace"
                          className="backspace-icon"
                        />
                      ) : (
                        value
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      <AccessKeyModal ref={accessKeyModalRef} />
    </div>
  );
};

export default PaymentPage;
